import { render, staticRenderFns } from "./PharmaForm.vue?vue&type=template&id=cf53466a&"
import script from "./PharmaForm.vue?vue&type=script&lang=js&"
export * from "./PharmaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports